import React from "react";
import { Container, makeStyles, LinearProgress } from "@material-ui/core";

import FunnelHeader from "components/header/funnelHeader";
import ShippingStep from "components/funnel/steps/funnelStepShipping";
import Stepper from "ui/stepper/Stepper";
import { STEPS, STEPS_NAMES, STEP_SHIPPING, STEP_PAYMENT } from "components/funnel/constants";
import useFunnelValidator from "hooks/useFunnelValidator";

export default function Livraison() {
  const classes = useStyle();
  const activeStepIndex = STEPS.findIndex((el) => el === STEP_SHIPPING) + 1;
  const [isValidating] = useFunnelValidator(STEP_SHIPPING);
  return (
    <div className={classes.container}>
      <FunnelHeader>
        <Stepper steps={STEPS} stepsNames={STEPS_NAMES} activeStep={activeStepIndex} />
      </FunnelHeader>
      <Container className={classes.inner} disableGutters>
        {isValidating ? <LinearProgress /> : <ShippingStep prevHref={STEP_PAYMENT} />}
      </Container>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    position: "relative",
  },
  inner: {
    paddingTop: theme.spacing(4),
    maxWidth: 1120,
  },
}));
